// extracted by mini-css-extract-plugin
export default {"Header":"AppLoadingPage__Header__L9amH","LogoWrapper":"AppLoadingPage__LogoWrapper__BHRKy","Sidebar":"AppLoadingPage__Sidebar__2jalZ","Content":"AppLoadingPage__Content__nXabm"};